const ContactMap = () => {
  return (
    <>
      <section className="contact__map">
        <div className="contact__map-wrap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3447.2875592393666!2d-71.96065676353463!3d45.39713574032051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb7b4c753aab3c3%3A0x1a6662a1c84826d1!2s3995%20Rue%20Lesage%2C%20Sherbrooke%2C%20QC%20J1L%202Z9%2C%20Canada!5e1!3m2!1sen!2stn!4v1758295024003!5m2!1sen!2stn"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map of Sherbrooke Location"
          ></iframe>
          <div className="contact__map-icon">
            <i className="fa-solid fa-location-dot"></i>
            <img src="assets/img/bg/contact-icon-bg.png" alt="" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactMap;
